import React, { ChangeEvent } from 'react';
import { connect } from 'react-redux';

import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import {
  deleteAfterEffectsJob,
  getAfterEffectsGeneratorJobs,
  postAfterEffectsGeneratorJob,
} from '../../../api/clipGenV2/afterEffectsGeneratorJob.actions';
import { baseMapStateToProps } from '../../componentBase';
import { createModalCloseAction } from '../../../actions/modalActions';
import { SimpleModalId } from '../../../constants/modalId';

import * as NotificationHelper from 'helpers/notificationHelper';
import { callApi } from 'helpers/callApi/callApi';
import { JobsTable } from './jobsTable';
import { JobManagementProps, JobManagementStates } from './job.types';
import { CreateJobRequestDataProps } from './createJobForm.types';
import { CreateJobFormContainer } from './createJobForm';

class JobManagement extends React.Component<JobManagementProps, JobManagementStates> {
  state: JobManagementStates = {
    jobs: [],
    getJobsLoading: false,
    getJobsError: false,
    postJobsLoading: false,
    uploadCustomMusic: false,
    deleteJobLoading: false,
  };

  componentDidMount() {
    this.getJobs();
  }

  getJobs = () => {
    const { getAfterEffectsJobs } = this.props;

    callApi({
      action: () => {
        this.setState(prev => ({ ...prev, getJobsLoading: true }));

        return getAfterEffectsJobs();
      },
      onSuccess: ({ payload }) => {
        this.setState(prev => ({ ...prev, jobs: payload, getJobsLoading: false, getJobsError: false }));
      },
      onFailure: () => this.setState({ jobs: [], getJobsLoading: false, getJobsError: true }),
    });
  };

  createJob = (job: CreateJobRequestDataProps) => {
    const { postAfterEffectsJob, closeCreateJobModal } = this.props;

    callApi({
      action: () => {
        this.setState(prev => ({ ...prev, postJobsLoading: true }));

        return postAfterEffectsJob(job);
      },
      onSuccess: () => {
        this.setState(prev => ({ ...prev, postJobsLoading: false }));
        closeCreateJobModal();
        NotificationHelper.success('Successfully created job!');
        this.getJobs();
      },
      onFailure: () => {
        this.setState(prev => ({ ...prev, postJobsLoading: false }));
        NotificationHelper.error('Failed to create job!');
      },
    });
  };

  deleteJob = (jobId: string) => {
    const { deleteJob } = this.props;

    callApi({
      action: () => {
        this.setState(prev => ({ ...prev, deleteJobLoading: true }));

        return deleteJob(jobId);
      },
      onSuccess: () => {
        this.setState(prev => ({ ...prev, deleteJobLoading: false }));
        NotificationHelper.success('Successfully deleted job!');
        this.getJobs();
      },
      onFailure: () => {
        this.setState(prev => ({ ...prev, deleteJobLoading: false }));
        NotificationHelper.error('Failed to delete music!');
      },
    });
  };

  handleMusicToggleChange = (e: ChangeEvent<HTMLInputElement>) =>
    this.setState({ uploadCustomMusic: e.target.checked });

  render = () => {
    const { jobs, getJobsLoading, getJobsError, postJobsLoading, uploadCustomMusic, deleteJobLoading } = this.state;
    const { afterEffectsTemplates, afterEffectsMusic } = this.props;
    const isLoading = getJobsLoading || postJobsLoading || deleteJobLoading;

    if (getJobsError) {
      return <div>Something went wrong</div>;
    }

    return (
      <>
        <CreateJobFormContainer
          form="createJobForm"
          templates={afterEffectsTemplates}
          musicFiles={afterEffectsMusic}
          onSubmit={this.createJob}
          onMusicToggleChange={this.handleMusicToggleChange}
          uploadCustomMusic={uploadCustomMusic}
          isLoading={postJobsLoading}
        />
        <JobsTable jobs={jobs} isLoading={isLoading} onClickDelete={this.deleteJob} />
      </>
    );
  };
}

const mapDispatchToProps = (dispatch: Function) => ({
  deleteJob: (jobId: string) => dispatch(deleteAfterEffectsJob(jobId)),
  getAfterEffectsJobs: () => dispatch(getAfterEffectsGeneratorJobs()),
  postAfterEffectsJob: (job: CreateJobRequestDataProps) => dispatch(postAfterEffectsGeneratorJob(job)),
  closeCreateJobModal: () => dispatch(createModalCloseAction(SimpleModalId.CreateJobModal)),
});

const mapStateToProps = (state: ClippingPlatformState) => baseMapStateToProps(state);

export const JobManagementContainer = connect(mapStateToProps, mapDispatchToProps)(JobManagement);
